export default __webpack_public_path__ + "static/media/camera_screen_bg.cf3cfdab.png";